import { BsAjax, BsGetcapis, BsGetCid, BsUtil, BsGetXcx } from 'dida-web-common'
import DATA from './../pageConf.js'

export default async function getActiveData(_v, acCode, acType, condition, paramsList, fn) {
    try {
        // 获取必要的基础数据
        const { cid } = await BsGetCid()
        const { isWx } = await BsGetXcx()
        const { url, activityType, params, activityCode, guestUrl, promotionCode: cmspromotionCode } = DATA.options.basic?.getDataMes || DATA.options.basic
        if (!cmspromotionCode) return
        const { sceneCode, activityCode: url_activityCode, promotionCode, conditionList, shareCode } = BsUtil.getQuery()
        condition = condition || conditionList
         // 根据活动类型决定请求方式和数据格式
         let isFormData = activityType === 5
         let activityTypeNew = activityType
        // 确定请求的URL
        let requestUrl = url
        if (!_v.liebianPageCommon && (isFormData || shareCode) && location.pathname.includes('guest')) {
            // 砍一刀需要手动助力
            if (_v.productName === 'web-10d39cp' || _v.productName === 'web-10d5b2r') return
            requestUrl = guestUrl || '/activity-platform/interact/guest/help'
            isFormData = true
            activityTypeNew = 5
        }

        // 构造请求数据
        const requestData = Object.assign({
            ...(params || {}),
            userCid: cid,
            terminalType: isFormData ? 4 : (isWx ? 'MINI_PG' : 'APP'),
            ...(acCode && { activityCode: acCode }),
            ...(condition && { conditionList: condition }),
            ...(acType && { activityTemplateType: acType }),
            ...(isFormData && shareCode && {
                shareCode,
                resultType: 0,
                needUserTask: 1
            })
        }, {
            ...(sceneCode && { sceneCode: sceneCode }),
            ...(activityType !== 'dacu' && url_activityCode && { activityCode: url_activityCode }),
            ...(promotionCode && { promotionCode: promotionCode })
        }, { ...paramsList })

        const method = isFormData ? 'POST' : 'GET'
        const requestPayload = isFormData ? BsUtil.stringify(requestData) : requestData

        // 发送请求
        const response = await BsAjax({
            method,
            url: `${BsGetcapis}/web${requestUrl || '/activity-platform/promotion/act/predict'}`,
            [isFormData ? 'data' : 'params']: requestPayload
        })
        fn && fn(response)
        try {
            _v.$track.addStat('interface_loadedss', {
                code1: response?.data?.map?.code,
                message1: response?.data?.map?.message,
                dataList: JSON.stringify(response?.data?.map || {})
            })
        } catch (error) {
            console.log(error)
        }
        // 处理响应数据
        const activityList = processResponseData(response, activityTypeNew, activityCode)

        // 更新 Vue 实例数据
        // if (acCode || acType) {
        //     Object.keys(activityList).forEach(key => {
        //         _v.$set(_v.$data.activeData, key, activityList[key])
        //     })
        // } else {
        //     _v.$set(_v.$data, 'activeData', activityList)
        // }
        // _v.$set(_v.$data, 'activeData', { ..._v.activeData, ...activityList })
        _v.$root.$data.activeData = { ..._v.$root.$data.activeData, ...activityList }
        // 触发事件
        _v.$bus.$emit('updateActiveDate')
    } catch (error) {
        console.error('Failed to fetch active data:', error)
        _v.$didafe?.toast('网络异常，请稍后重试')
    }
}

/**
 * 处理响应数据，构造活动列表
 */
function processResponseData(response, activityType, activityCode) {
    const activityList = {
        activeKey: []
    }

    if (activityType !== 'dacu') {
        const { data } = response
        activityList.promotionStatus = data?.data?.errorCode || data?.code
        activityList.promotionMsg = data?.data?.errorMsg || data?.message
        activityList[activityType] = [{
            activityCode,
            activityInfo: data?.data,
            code: data?.data?.errorCode || data?.code,
            msg: data?.data?.errorMsg || data?.message
        }]
    } else {
        const { map } = response.data
        activityList.hitUserGroup = map?.data?.hitUserGroup
        activityList.promotionStatus = map?.code ?? response.data.code
        activityList.promotionMsg = map?.message ?? response.data.message
        activityList.currentTime = map?.data?.currentTime
        // activityList.promotionMessage = map?.promotionMessage ?? response.data.promotionMessage

        if (map?.data) {
            const leibianCode = {}
            const shengjiCode = {}
            map.data.activityTemplateList?.forEach(item => {
                item.activityList?.forEach(activity => {
                    if (activity?.activityInfo && typeof activity.activityInfo === 'string') {
                        try {
                            activity.activityInfo = JSON.parse(activity.activityInfo) || {}
                        } catch {
                            activity.activityInfo = {}
                        }
                    }

                    const typeKey = item.activityTemplateType
                    const locationKey = activity?.locationCode ? `${typeKey}_${activity.locationCode}` : `${typeKey}`
                    // 获取基于位置的活动编码
                    const locationActivityCode = activity?.locationCode ? `activityCode_${activity.locationCode}` : `activityCode`

                    if (typeKey === 5) {
                        // 裂变活动
                        const activityCode = activity.activityCode
                        if (activity?.activityInfo?.activityInfo?.material?.frontStyleTemplate === 13) {
                            leibianCode[locationActivityCode] = activityCode
                        } else {
                            activityList[locationActivityCode] = activityCode
                        }
                    }

                    if (typeKey === 10) {
                        // 升级活动
                        shengjiCode[locationActivityCode] = activity.activityCode
                    }

                    Object.keys(leibianCode).forEach(item => {
                        activityList[item] = shengjiCode[item] ? [leibianCode[item], shengjiCode[item]] : leibianCode[item]
                    })

                    activityList.activeKey.push(locationKey)

                    if (!activityList[locationKey]) activityList[locationKey] = []
                    activityList[locationKey].push(activity)
                })
            })
        }
    }

    return activityList
}
